import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=c529437a&scoped=true&"
import script from "./PortalLayout.vue?vue&type=script&lang=js&"
export * from "./PortalLayout.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/site.css?vue&type=style&index=0&id=c529437a&prod&scoped=true&lang=css&"
import style1 from "./PortalLayout.vue?vue&type=style&index=1&id=c529437a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c529437a",
  null
  
)

export default component.exports